export enum LayersDataTypes {
  Map2D = 1,
  Map3D = 2,
  Plots = 3,
  InvestmentOpportunities = 4,
  AdminBuildings = 5,
  Roads = 6,
  CityBoundary = 7,
  LogisticInfrastructure = 8,
  ElectricityInfrastructure = 9,
  WaterInfrastructure = 10,
  TelecomInfrastructure = 11,
  SewerageInfrastructure = 12,
  GasInfrastructure = 13,
  SpacesForRent = 14,
  OmanBorder = 16,
  Reports = 17,
  BaseMap = 18,
  NCSI = 19,
  OPIS = 20,
}

export const MainDataTypeIds: number[] = [
  LayersDataTypes.CityBoundary,
  LayersDataTypes.Plots,
  LayersDataTypes.InvestmentOpportunities,
  LayersDataTypes.SpacesForRent
]

export const InfrastructureTypeIds: number[] = [
  LayersDataTypes.LogisticInfrastructure,
  LayersDataTypes.ElectricityInfrastructure,
  LayersDataTypes.WaterInfrastructure,
  LayersDataTypes.TelecomInfrastructure,
  LayersDataTypes.SewerageInfrastructure,
  LayersDataTypes.GasInfrastructure,
]
